// Function definitions
const index = function (params) {
    return window.axios.get('/api/overtime', {params});
};

const engineer = function (params) {
    return window.axios.get('/api/overtime/engineer', {params});
};

const get = function (id) {
    return window.axios.get('/api/overtime/' + id);
};

const store = function (data) {
    return window.axios.post('/api/overtime', data);
};

const update = function (data) {
    return window.axios.put('/api/overtime/' + data.id, data);
};

const save = function(data) {
    if (data.id) {
        return update(data);
    }

    return store(data);
};

const deleteOvertime = function(id) {
    return window.axios.delete('/api/overtime/' + id);
};

export default {
    index,
    engineer,
    get,
    store,
    update,
    save,
    delete: deleteOvertime,
}



// WEBPACK FOOTER //
// ./resources/assets/js/services/OvertimeService.js